<template>
  <div class="px-5 select-ctn d-flex flex-row align-items-center">
    <label class="mb-0 mr-3">
      Sort by
    </label>
    <b-form-select
      id="sort-input"
      v-model="selected"
      :options="options"
      :plain="true"
      @change="selectChange"
    ></b-form-select>
  </div>
</template>

<script>
import Store from "@/store";

export default {
  data() {
    return {
      selected: "yieldStrengthMPa",
      options: [
        { value: "brandName", text: "Alloy Name" },
        { value: "yieldStrengthMPa", text: "Yield Strength" },
        { value: "tensileStrengthMPa", text: "Tensile Strength" },
        {
          value: "electricalConductivityIACS",
          text: "Electrical Conductivity"
        },
        { value: "density", text: "Density" }
      ]
    };
  },
  methods: {
    selectChange() {
      Store.sortAlloysItems(this.selected);
    },
    resetSorting() {
      this.selected = "yieldStrengthMPa";
    }
  }
};
</script>

<style lang="scss" scoped>
#sort-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
}
label {
  white-space: nowrap;
}
.select-ctn {
  position: relative;
  .form-control {
    border-radius: 30px;
    border: 1px solid gray;
    background-image: url("../assets/arrowDown.png");
    background-size: 8px;
    background-repeat: no-repeat;
    background-position: bottom 50% right 16px;
  }
}
</style>
